import { render, staticRenderFns } from "./YouAndMeTextAdmin.vue?vue&type=template&id=038b0781&scoped=true&"
import script from "./YouAndMeTextAdmin.vue?vue&type=script&lang=js&"
export * from "./YouAndMeTextAdmin.vue?vue&type=script&lang=js&"
import style0 from "./YouAndMeTextAdmin.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./YouAndMeTextAdmin.vue?vue&type=style&index=1&id=038b0781&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038b0781",
  null
  
)

export default component.exports